import {assert} from 'Asserts';

export enum LockedTableWarningType {
  ARCHIVED_SCHEMA,
  DEACTIVATED_BATCH_SCHEMA,
  GENERIC,
}

export function getLockedTableWarningMessage(warningType: LockedTableWarningType): string {
  switch (warningType) {
    case LockedTableWarningType.ARCHIVED_SCHEMA:
      return 'Editing disabled when schema is archived.';
    case LockedTableWarningType.DEACTIVATED_BATCH_SCHEMA:
      return 'Editing disabled when schema is deactivated.';
    case LockedTableWarningType.GENERIC:
      return 'Editing disabled for locked table.';
    default:
      assert(false, `Unexpected warning type for locked table: ${warningType}`);
      return '';
  }
}

export enum LockedCellWarningType {
  ALREADY_REGISTERED,
  GENERIC,
}

export function getLockedCellWarningMessage(warningType: LockedCellWarningType): string {
  switch (warningType) {
    case LockedCellWarningType.ALREADY_REGISTERED:
      return 'Editing disabled for registered values.';
    case LockedCellWarningType.GENERIC:
      return 'Editing disabled for locked cells.';
    default:
      assert(false, `Unexpected warning type for locked cells: ${warningType}`);
      return '';
  }
}
